import { forwardRef } from "react";
function SvgRawDraftIcon({ title, titleId, ...props }, ref) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 32 32"
      role="img"
      ref={ref}
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <path
        stroke="#1D1D1D"
        strokeLinejoin="round"
        strokeWidth={2}
        d="M6 27a1 1 0 0 0 1 1h18a1 1 0 0 0 1-1V8l-4-4H7a1 1 0 0 0-1 1v22Z"
        clipRule="evenodd"
      />
      <path
        fill="#1D1D1D"
        fillRule="evenodd"
        d="M20 10h6V8l-4-4h-2v6Z"
        clipRule="evenodd"
      />
      <path
        stroke="#1D1D1D"
        strokeLinecap="round"
        strokeWidth={2}
        d="M15 12.667v4.571l4 3.429"
      />
    </svg>
  );
}
const ForwardRef = forwardRef(SvgRawDraftIcon);
export default ForwardRef;
